module.exports = __webpack_public_path__ + "static/media/SI.6e4391c9.webp";